import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import ContactView from './ContactView';

const route: FuseRouteItemType = {
	path: 'contact',
	element: <ContactView />
};

export default route;
